import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  checking: false,
  errorMessage: undefined,
  successMessage: undefined,
  schedule: undefined,
  quizPatient: undefined,
};

export const secretarySlice = createSlice({
  name: "secretary",
  initialState,
  reducers: {
    onChecking: (state) => ({
      ...state,
      checking: true,
      errorMessage: undefined,
      successMessage: undefined,
    }),
    onNotChecking: (state) => ({
      ...state,
      checking: false,
    }),
    onErrorMessage: (state, { payload }) => ({
      ...state,
      checking: false,
      successMessage: undefined,
      errorMessage: payload,
    }),
    onSuccesMessage: (state, { payload }) => ({
      ...initialState,
      patientsList: state.patientsList,
      doctorsList: state.doctorsList,
      surgeryRooms: state.surgeryRooms,
      schedule: state.schedule,
      successMessage: payload,
    }),
  },
});

// Action creators are generated for each case reducer function
export const { onChecking, onNotChecking, onErrorMessage, onSuccesMessage } =
  secretarySlice.actions;
